// Screener filters cluster (Phase 5 Step 6 — first mid-layer extraction, dependency-injected).
// Imports only leaves (ui, state). Its back-calls into app.js (computeIndustryGroupRanks,
// screenerPassesPreset, rsCohortPredicate, renderScreenerResults, setScreenerResults) are INJECTED
// via configure() at boot — breaking what would otherwise be a circular import. Code moved verbatim
// from app.js (8-space indent preserved intentionally: template-literal whitespace is significant;
// esbuild strips it on minify).
import { ui } from './ui.js';
import { state } from './state.js';
import { buildScreenTree, evaluateScreen, CLAUSES, encodeScreen, decodeScreen } from './screen/index.js';

let _deps = {};
export function configure(d) { _deps = { ..._deps, ...d }; }

        export const SCR_FILTER_CATALOG = [
            { fk: 'scrMinPrice',          label: 'Price≥',     def: '1', dv: '10' },
            { fk: 'scrMinAvgVol',         label: 'Vol≥',    def: '200000' },
            { fk: 'scrMaxDeep',           label: 'Max Deep',      def: '0' },
            { fk: 'scrMinScore',          label: 'Score≥',     def: '0', dv: '300' },
            { fk: 'scrMaxRmv',            label: 'RMV≤',       def: '100' },
            { fk: 'scrMinBqs',            label: 'BQS≥',       def: '0' },
            { fk: 'scrSignalFilter',      label: 'Signal',        def: 'any' },
            { fk: 'scrTierFilter',        label: 'Tier',          def: 'any' },
            { fk: 'scrStageFilter',       label: 'Stage',         def: 'any' },
            { fk: 'scrRmvZoneFilter',     label: 'RMV Zone',      def: 'any' },
            { fk: 'scrVolumeSignalFilter',label: 'Vol Sig', def: 'any' },
            { fk: 'scrExtensionFilter',   label: 'Extension',     def: 'any' },
            { fk: 'scrChannelFilter',     label: 'Channel',       def: 'any' },
            { fk: 'scrOmegaFilter',       label: 'Omega',         def: 'any' },
            { fk: 'scrSectorFilter',      label: 'Sector',        def: 'any' },
            { fk: 'scrGroupFilter',       label: 'Group',  def: '' },
            { fk: 'scrMaxGroupRank',      label: 'Grp Rank≤',def: '999' },
            { fk: 'scrEpsAccelFilter',    label: 'EPS Accel',     def: 'any' },
            { fk: 'scrSalesAccelFilter',  label: 'Sales Accel',   def: 'any' },
            { fk: 'scrGrowthFilter',      label: 'Growth',        def: 'any' },
            { fk: 'scrMinDollarVol',      label: 'Min $ Vol',     def: '0', dv: '100000000' },
            { fk: 'scrMinRvol',           label: 'RVOL≥',      def: '0', dv: '1' },
            { fk: 'scrMinPerf1d',         label: '1D%≥',      def: '-999' },
            { fk: 'scrMinPerf1w',         label: '1W%≥',      def: '-999' },
            { fk: 'scrMinPerf1m',         label: '1M%≥',      def: '-999' },
            { fk: 'scrMinPerf3m',         label: '3M%≥',      def: '-999' },
            { fk: 'scrMinPerf6m',         label: '6M%≥',      def: '-999' },
            { fk: 'scrMinPerf12m',        label: '12M%≥',     def: '-999' },
            { fk: 'scrMinRsi', label: 'RSI≥', def: '0' },
            { fk: 'scrMaxRsi', label: 'RSI≤', def: '100' },
            { fk: 'scrMinMv', label: 'Minervini≥', def: '0' },
            { fk: 'scrMin9ema', label: '9E≥', def: '-999' },
            { fk: 'scrMax9ema', label: '9E≤', def: '999' },
            { fk: 'scrMin21ema', label: '21E≥', def: '-999' },
            { fk: 'scrMax21ema', label: '21E≤', def: '999' },
            { fk: 'scrMin50sma', label: '50S≥', def: '-999' },
            { fk: 'scrMax50sma', label: '50S≤', def: '999' },
            { fk: 'scrMin200sma', label: '200S≥', def: '-999' },
            { fk: 'scrMax200sma', label: '200S≤', def: '999' },
            { fk: 'scrVcpFilter', label: 'VCP', def: 'any' },
            { fk: 'scrRsnhFilter', label: 'RS NH', def: 'any' },
            { fk: 'scrLeadershipFilter', label: 'Lead', def: 'any' },
            { fk: 'scrMinAdr',            label: 'ADR%≥',      def: '0', dv: '4' },
            { fk: 'scrMaxAdr',            label: 'ADR%≤',      def: '100' },
            { fk: 'scrMinTrend',          label: 'Trend≥',     def: '0' },
            { fk: 'scrMinDemand',         label: 'Demand≥',    def: '0' },
            { fk: 'scrMinTiming',         label: 'Timing≥',    def: '0' }
        ];
        const SCR_DEFAULT_ACTIVE = ['scrMinPrice', 'scrMinScore', 'scrSignalFilter', 'scrChannelFilter', 'scrGroupFilter', 'scrEpsAccelFilter', 'scrSalesAccelFilter', 'scrMinDollarVol', 'scrMinRvol', 'scrMax9ema', 'scrMinAdr'];
        const SCR_FILTERS_KEY = 'abScreenerActiveFiltersV2';

        export const FilterUI = (() => {
            let active = new Set();

            function loadActive() {
                try {
                    const raw = localStorage.getItem(SCR_FILTERS_KEY);
                    if (raw) {
                        const arr = JSON.parse(raw);
                        if (Array.isArray(arr)) return new Set(arr.filter(fk => SCR_FILTER_CATALOG.some(c => c.fk === fk)));
                    }
                } catch (e) {}
                return new Set(SCR_DEFAULT_ACTIVE);
            }
            function persist() {
                try { localStorage.setItem(SCR_FILTERS_KEY, JSON.stringify([...active])); } catch (e) {}
            }

            function defFor(fk) { return (SCR_FILTER_CATALOG.find(c => c.fk === fk) || {}).def ?? ''; }

            // Ensure each field label carries a remove "×" button (added once).
            // The field lives inside a <label>, which natively forwards clicks to its
            // input — so we use a real <button type=button>, kill the label default,
            // and fire on mousedown (which beats the label's click-activation).
            function ensureChipX(label) {
                if (label.querySelector('.scr-chip-x')) return;
                const fk = label.dataset.fk;
                const btn = document.createElement('button');
                btn.type = 'button';
                btn.className = 'scr-chip-x';
                btn.title = 'Remove filter';
                btn.setAttribute('aria-label', 'Remove filter');
                btn.innerHTML = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" style="width:12px;height:12px;pointer-events:none;"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2.5" d="M6 18L18 6M6 6l12 12"></path></svg>';
                const kill = (e) => { e.preventDefault(); e.stopPropagation(); };
                btn.addEventListener('mousedown', (e) => { kill(e); remove(fk); });
                btn.addEventListener('click', kill);
                label.appendChild(btn);
            }

            function render() {
                SCR_FILTER_CATALOG.forEach(c => {
                    const label = document.querySelector(`[data-fk="${c.fk}"]`);
                    if (!label) return;
                    ensureChipX(label);
                    label.classList.toggle('scr-on', active.has(c.fk));
                });
                const countEl = document.getElementById('scrActiveCount');
                if (countEl) countEl.textContent = active.size ? `· ${active.size} active` : '· none';
                renderPickerList();
            }

            function add(fk) {
                active.add(fk);
                persist();
                render();
                const el = document.getElementById(fk);
                if (el) el.focus();
            }
            function remove(fk) {
                active.delete(fk);
                // Reset the underlying control to its default so it stops constraining the scan.
                const el = document.getElementById(fk);
                if (el) el.value = defFor(fk);
                persist();
                render();
                if (typeof applyScreenerFilters === 'function') applyScreenerFilters();
            }
            function resetAll() {
                SCR_FILTER_CATALOG.forEach(c => {
                    const el = document.getElementById(c.fk);
                    if (el) el.value = SCR_DEFAULT_ACTIVE.includes(c.fk) ? (c.dv != null ? c.dv : c.def) : c.def;
                });
                active = new Set(SCR_DEFAULT_ACTIVE);
                persist();
                render();
                if (typeof applyScreenerFilters === 'function') applyScreenerFilters();
            }

            function renderPickerList(query = '') {
                const list = document.getElementById('scrFilterPickerList');
                if (!list) return;
                const q = query.trim().toLowerCase();
                list.innerHTML = SCR_FILTER_CATALOG
                    .filter(c => !q || c.label.toLowerCase().includes(q))
                    .map(c => {
                        const on = active.has(c.fk);
                        return `<div class="scr-pick-row ${on ? 'scr-pick-disabled' : ''}" data-pick="${c.fk}">
                            <span>${c.label}</span>
                            ${on
                                ? '<svg class="w-3 h-3" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2.5" d="M5 13l4 4L19 7"></path></svg>'
                                : '<svg class="w-3 h-3 text-slate-500" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2.5" d="M12 4v16m8-8H4"></path></svg>'}
                        </div>`;
                    }).join('') || '<div class="scr-pick-row scr-pick-disabled"><span>No match</span></div>';
            }

            function openPicker() {
                const p = document.getElementById('scrFilterPicker');
                if (!p) return;
                p.classList.remove('hidden');
                renderPickerList('');
                const s = document.getElementById('scrFilterSearch');
                if (s) { s.value = ''; s.focus(); }
            }
            function closePicker() {
                const p = document.getElementById('scrFilterPicker');
                if (p) p.classList.add('hidden');
            }
            function togglePicker() {
                const p = document.getElementById('scrFilterPicker');
                if (!p) return;
                if (p.classList.contains('hidden')) openPicker(); else closePicker();
            }

            function init() {
                active = loadActive();
                render();
                const addBtn = document.getElementById('scrAddFilterBtn');
                const resetBtn = document.getElementById('scrResetFiltersBtn');
                const search = document.getElementById('scrFilterSearch');
                const list = document.getElementById('scrFilterPickerList');
                if (addBtn) addBtn.addEventListener('click', (e) => { e.stopPropagation(); togglePicker(); });
                if (resetBtn) resetBtn.addEventListener('click', resetAll);
                if (search) search.addEventListener('input', () => renderPickerList(search.value));
                if (list) list.addEventListener('click', (e) => {
                    const row = e.target.closest('[data-pick]');
                    if (!row || row.classList.contains('scr-pick-disabled')) return;
                    add(row.dataset.pick);
                    renderPickerList(search ? search.value : '');
                });
                // Close picker on outside click.
                document.addEventListener('click', (e) => {
                    const p = document.getElementById('scrFilterPicker');
                    if (!p || p.classList.contains('hidden')) return;
                    if (!p.contains(e.target) && e.target.id !== 'scrAddFilterBtn' && !e.target.closest('#scrAddFilterBtn')) closePicker();
                });
            }

            // Phase 6 Step 2: bulk get/set the active-chip set for URL hydrate/serialize. setActive mirrors
            // resetAll's active-set handling but does NOT touch control values (hydration sets those itself).
            function getActive() { return [...active]; }
            function setActive(fkList) {
                active = new Set((fkList || []).filter(fk => SCR_FILTER_CATALOG.some(c => c.fk === fk)));
                persist();
                render();
            }
            return { init, render, add, remove, resetAll, isActive: (fk) => active.has(fk), getActive, setActive };
        })();

        export function setScreenerPreset(preset) {
            state.screenerPreset = preset || 'daily';
            if (!ui.screenerPresetChips) return;
            ui.screenerPresetChips.querySelectorAll('.screener-chip').forEach(btn => {
                const active = btn.dataset.preset === state.screenerPreset;
                btn.classList.toggle('active', active);
                btn.classList.toggle('bg-blue-900/30', active);
                btn.classList.toggle('border-blue-500/60', active);
                btn.classList.toggle('text-blue-100', active);
                btn.classList.toggle('bg-slate-900', !active);
                btn.classList.toggle('border-slate-700', !active);
                btn.classList.toggle('text-slate-300', !active);
            });
            applyScreenerFilters();
        }

        function getScreenerFilters() {
            return {
                minPrice: Number(ui.scrMinPrice?.value || 0),
                minAvgVol: Number(ui.scrMinAvgVol?.value || 0),
                maxDeep: Number(ui.scrMaxDeep?.value || 0),
                minScore: Number(ui.scrMinScore?.value || 0),
                maxRmv: Number(ui.scrMaxRmv?.value || 100),
                minBqs: Number(ui.scrMinBqs?.value || 0),
                signal: ui.scrSignalFilter?.value || 'any',
                tier: ui.scrTierFilter?.value || 'any',
                stage: ui.scrStageFilter?.value || 'any',
                channel: ui.scrChannelFilter?.value || 'any',
                omega: ui.scrOmegaFilter?.value || 'any',
                rmvZone: ui.scrRmvZoneFilter?.value || 'any',
                volumeSignal: ui.scrVolumeSignalFilter?.value || 'any',
                extension: ui.scrExtensionFilter?.value || 'any',
                epsAccel: ui.scrEpsAccelFilter?.value || 'any',
                salesAccel: ui.scrSalesAccelFilter?.value || 'any',
                growth: ui.scrGrowthFilter?.value || 'any',
                minDollarVol: Number(ui.scrMinDollarVol?.value || 0),
                minRvol: Number(ui.scrMinRvol?.value || 0),
                minPerf1d: Number(ui.scrMinPerf1d?.value || -999),
                minPerf1w: Number(ui.scrMinPerf1w?.value || -999),
                minPerf1m: Number(ui.scrMinPerf1m?.value || -999),
                minPerf3m: Number(ui.scrMinPerf3m?.value || -999),
                minPerf6m: Number(ui.scrMinPerf6m?.value || -999),
                minPerf12m: Number(ui.scrMinPerf12m?.value || -999),
                minRsi: Number(ui.scrMinRsi?.value || 0),
                maxRsi: Number(ui.scrMaxRsi?.value || 100),
                minMv: Number(ui.scrMinMv?.value || 0),
                min9ema: Number(ui.scrMin9ema?.value || -999), max9ema: Number(ui.scrMax9ema?.value || 999),
                min21ema: Number(ui.scrMin21ema?.value || -999), max21ema: Number(ui.scrMax21ema?.value || 999),
                min50sma: Number(ui.scrMin50sma?.value || -999), max50sma: Number(ui.scrMax50sma?.value || 999),
                min200sma: Number(ui.scrMin200sma?.value || -999), max200sma: Number(ui.scrMax200sma?.value || 999),
                vcp: ui.scrVcpFilter?.value || 'any',
                rsnh: ui.scrRsnhFilter?.value || 'any',
                leadership: ui.scrLeadershipFilter?.value || 'any',
                minAdr: Number(ui.scrMinAdr?.value || 0),
                maxAdr: Number(ui.scrMaxAdr?.value || 100),
                sector: ui.scrSectorFilter?.value || 'any',
                group: (ui.scrGroupFilter?.value || '').trim().toLowerCase(),
                maxGroupRank: Number(ui.scrMaxGroupRank?.value || 999),
                minTrend: Number(ui.scrMinTrend?.value || 0),
                minDemand: Number(ui.scrMinDemand?.value || 0),
                minTiming: Number(ui.scrMinTiming?.value || 0)
            };
        }

        export function applyScreenerFilters() {
            const filters = getScreenerFilters();
            _deps.computeIndustryGroupRanks();
            // Phase 6 Step 1: the ~60 imperative field guards were lifted into a serializable filter
            // tree evaluated by the pure src/screen/ module (behavior-IDENTICAL — proven byte-for-byte
            // by tests/screen_equivalence.test.js). buildScreenTree(filters) captures the DOM-derived
            // filter values into a flat-AND tree; evaluateScreen walks it per row. The preset gate stays
            // an injected predicate ANDed here (folded into the serialized screen in Step 2); the RS
            // cohort stays a separate post-filter below — neither behavior changes.
            const _screenTree = buildScreenTree(filters);
            const _filteredScreenerRows = state.screenerAllResults.filter(row =>
                evaluateScreen(_screenTree, row) && _deps.screenerPassesPreset(row));
            let _outRows = _filteredScreenerRows;
            const _cohortPred = _deps.rsCohortPredicate(state.screenerRsCohort);
            if (_cohortPred) _outRows = _outRows.filter(_cohortPred);
            _deps.setScreenerResults(_outRows);
            _deps.renderScreenerResults();
            // Phase 6 Step 2: single serialize hook — filters/preset/cohort all route through here.
            // Optional injected dep (no-op when absent); the shell debounces + guards it (URL write).
            if (typeof _deps.onScreenChange === 'function') _deps.onScreenChange();
        }


if (typeof window !== 'undefined') {
    window.screenerFilters = { configure, applyScreenerFilters, getScreenerFilters, setScreenerPreset, FilterUI, deps: () => _deps };
    // Phase 6 test surface: the pure screen-as-data API (equivalence test boots the bundle and
    // compares this evaluator against a frozen copy of the old imperative guards).
    window.PivotaScreen = { buildScreenTree, evaluateScreen, CLAUSES, encodeScreen, decodeScreen };
}
